import { __read } from 'tslib';
import React, { useState, useRef, useEffect } from 'react';
import cx from 'classnames';
import Capsule from '../../components/Capsule/index.js';
import result from '../../utils/userinfo.js';
import { getEnv } from '../../utils/getEnv.js';
import AvatarIcon from './Components/AvatarIcon/index.js';
import MobileMenu from './Components/MobileMenu/index.js';
import MenuIcon from './Components/MenuIcon/index.js';

var env = getEnv();
var MobileHeader = function MobileHeader(props) {
  var _a;
  var logo = props.logo,
    menus = props.menus,
    _b = props.needLogin,
    needLogin = _b === void 0 ? true : _b,
    _c = props.env,
    _env = _c === void 0 ? env : _c;
  var loginUrl = "https://login.bce".concat(_env === 'SANDBOX' ? 'test' : '', ".baidu.com/");
  var _d = __read(useState({}), 2),
    userInfo = _d[0],
    setUserInfo = _d[1];
  var headerRef = useRef(null);
  var headerWrapperRef = useRef(null);
  useEffect(function () {
    if (needLogin) {
      // 获取用户登录信息
      result.init(function (info) {
        info.hasLogin && setUserInfo(info);
      });
    }
    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  var handleScroll = function handleScroll() {
    if (!headerRef.current || !headerWrapperRef.current) return;
    var headerDom = headerRef.current;
    var scrollTop = document.documentElement.scrollTop;
    if (scrollTop === 0) {
      headerDom.style.top = '0';
    } else {
      headerDom.style.top = '8px';
    }
    if (scrollTop > 12) {
      headerDom.classList.add('qf-mobile-header-scroll');
    } else {
      headerDom.classList.remove('qf-mobile-header-scroll');
    }
  };
  // 登录
  var handleLogin = function handleLogin() {
    window.open(loginUrl + "?redirect=".concat(location.href), '_self');
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: headerWrapperRef,
    className: "qf-mobile-header-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    ref: headerRef,
    className: "qf-mobile-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-left"
  }, /*#__PURE__*/React.createElement("div", {
    className: "logo-wrapper"
  }, /*#__PURE__*/React.createElement("a", {
    href: logo.link,
    target: logo.target || '_blank'
  }, /*#__PURE__*/React.createElement("img", {
    src: logo.url,
    className: cx(logo.className),
    alt: "logo"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "header-right"
  }, needLogin && ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.hasLogin) ? (/*#__PURE__*/React.createElement("div", {
    className: "header-menu-wrapper"
  }, /*#__PURE__*/React.createElement(MobileMenu, {
    icon: /*#__PURE__*/React.createElement("span", {
      className: "header-user-name-logo"
    }, (_a = userInfo.displayName) === null || _a === void 0 ? void 0 : _a.slice(0, 1)),
    menus: [{
      title: '退出',
      link: "https://login.bce".concat(_env === 'SANDBOX' ? 'test' : '', ".baidu.com/logout?redirect=").concat(window.location.href),
      target: '_self'
    }]
  }))) : (/*#__PURE__*/React.createElement("span", {
    className: "header-user-icon",
    onClick: handleLogin,
    "data-track-name": "\u6309\u94AE\u70B9\u51FB",
    "data-track-value": "\u767B\u5F55",
    "data-track-category": "\u5934\u90E8\u5BFC\u822A"
  }, /*#__PURE__*/React.createElement(AvatarIcon, null)))), menus && (/*#__PURE__*/React.createElement("div", {
    className: "header-menu-wrapper"
  }, /*#__PURE__*/React.createElement(MobileMenu, {
    menus: menus,
    icon: /*#__PURE__*/React.createElement(MenuIcon, null)
  }))), /*#__PURE__*/React.createElement("div", {
    className: "header-capsule"
  }, /*#__PURE__*/React.createElement(Capsule, {
    isMobile: true,
    env: _env
  })))));
};

export { MobileHeader as default };
